import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import FullLogo from '../assets/FullLogo';

const Setup2FA = () => {
  const navigate = useNavigate();
  const emailFromState = useLocation().state?.email;
  const [email, setEmail] = useState(emailFromState);
  const [qrCode, setQrCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
 

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await authService.enable2FA(email);
      
      if (response && response.qrCode) {
        setQrCode(response.qrCode);
      } else {
        setError('QR code not received from server');
      }
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to enable 2FA');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="flex justify-center items-center mb-[60px]">
        <FullLogo width={"322"} height={"64"} />
      </div>
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-md">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-2">Setup Two-Factor Authentication</h2>
          <p className="text-gray-600">
            Enter your email to enable two-factor authentication
          </p>
        </div>

        {!qrCode ? (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                required
              />
            </div>

            {error && (
              <div className="text-red-500 text-sm text-center">{error}</div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 px-4 bg-yellow text-white rounded-md hover:bg-dark-yellow focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
            >
              {loading ? 'Processing...' : 'Enable 2FA'}
            </button>
          </form>
        ) : (
          <div className="space-y-6">
            <div className="text-center">
              <p className="mb-4">Scan this QR code with your authenticator app:</p>
              <div className="flex justify-center">
                <img 
                  src={qrCode} 
                  alt="2FA QR Code" 
                  className="border border-gray-300 p-2 rounded-md"
                  style={{ width: '200px', height: '200px' }}
                />
              </div>
              <p className="mt-4 text-sm text-gray-600">
                After scanning, you'll receive a 6-digit code in your authenticator app.
                Use this code whenever you log in.
              </p>
            </div>
            
            <button
              onClick={() => navigate('/2fa', { state: { email } })}
              className="w-full py-3 px-4 bg-yellow text-white rounded-md hover:bg-dark-yellow focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
            >
              Continue to Login
            </button>
          </div>
        )}

        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => navigate('/login')}
            className="text-blue-500 hover:text-blue-600 text-sm"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Setup2FA; 